<div class="message-center-container">
  <div
    (click)="toggleMenu()"
    (keydown.enter)="toggleMenu()"
    [attr.tabindex]="0"
    class="message-center-trigger"
  >
    <img 
      [src]="areNewMessages 
        ? 'assets/images/royal/message-center-new.svg' 
        : 'assets/images/royal/message-center.svg'" 
      alt="Message Center Icon"
      class="message-center-icon"
      loading="lazy"
    />
  </div>

  <div
    class="message-center-container__dropdown"
    [ngClass]="{ 'message-center-container__dropdown--open': menuOpen }"
  >
    <div class="message-center-container__triangle"></div>
    <div class="message-center-container__menu">
      <div class="message-center-container__menu-text">
        HERE COMES MESSAGE CENTER COMPONENT
      </div>
    </div>
  </div>
</div>
